import { create } from 'zustand';

import type { WizardData } from './schemas';

export type StepIndex = 0 | 1 | 2 | 3;

interface WizardState {
  step: StepIndex;
  data: WizardData;
  setStep: (step: StepIndex) => void;
  next: () => void;
  prev: () => void;
  patch: (partial: Partial<WizardData>) => void;
  reset: () => void;
}

const EMPTY_DATA: WizardData = {
  full_name: '',
  org_name: '',
  business_id: '',
  vat_id: '',
};

export const useWizardState = create<WizardState>((set) => ({
  step: 0,
  data: { ...EMPTY_DATA },
  setStep: (step) => { set({ step }); },
  next: () => { set((s) => ({ step: Math.min(3, s.step + 1) as StepIndex })); },
  prev: () => { set((s) => ({ step: Math.max(0, s.step - 1) as StepIndex })); },
  patch: (partial) => { set((s) => ({ data: { ...s.data, ...partial } })); },
  reset: () => { set({ step: 0, data: { ...EMPTY_DATA } }); },
}));
